export function formatDate(utcString, timeZone = 'UTC') {
    if (!utcString) return ''
    const date = new Date(utcString)
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        timeZone
    })
}
